'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _planEnquiryAnalyticsService = require('../plan/planEnquiryAnalyticsService');

var _ReferSheet = require('./ReferSheet');

var _ReferSheet2 = _interopRequireDefault(_ReferSheet);

require('./ReferModal.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var ReferModal = function ReferModal(props) {
    return _react2.default.createElement(_ReferSheet2.default, props);
};

// Analytics
// Lib


var googleAnalyticsReferralViewOnMount = (0, _recompose.lifecycle)({
    componentWillMount: _planEnquiryAnalyticsService.googleAnalyticsReferralViewEvent
});

exports.default = googleAnalyticsReferralViewOnMount(ReferModal);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/referral/ReferModal.js
// module id = 2077
// module chunks = 0